export class LabeledValue {
  constructor (public label: any, public value: any) {
    if (!value) this.value = label
  }
}
